module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-03"
  }, [_vm._v("The Cathedral Church of St. John the Divine stands in its beauty on Morningside Heights. The Stone Yard, started by Dean James Parks Morton, exists; and the dean and this exciting and unusual project are mentioned, as are Bishops Donegan and Moore, with affection and respect. But this is a work of fiction, and none of the imaginary characters bears any relation to any actual people, dead, living, or to be born.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336888be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 75
// module chunks = 0